import { ShoppingCart, Package, History, LayoutDashboard, CircleUserRound, IndianRupee, LogOut, BarChart, TrendingUp, Menu, X, ShoppingBag } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({ onLogout, isMobileOpen, onMobileToggle, shopName = 'StoreFlow' }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const navItems = [
        { id: 'profile', label: 'Profile', icon: CircleUserRound, path: '/profile' },
        { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/' },
        { id: 'inventory', label: 'Inventory', icon: Package, path: '/inventory' },
        { id: 'pos', label: 'Point of Sale', icon: ShoppingCart, path: '/pos' },
        { id: 'bulk-sales', label: 'Bulk Sales', icon: ShoppingBag, path: '/bulk-sales' },
        { id: 'history', label: 'Sales History', icon: History, path: '/history' },
        { id: 'restock-history', label: 'Restock History', icon: TrendingUp, path: '/restock-history' },
        { id: 'reports', label: 'Reports', icon: BarChart, path: '/reports' },
        { id: 'logout', label: 'Logout', icon: LogOut, action: 'logout' }
    ];

    const handleNavigation = (item) => {
        if (item.action === 'logout') {
            onLogout();
        } else {
            navigate(item.path);
        }
        // Close mobile sidebar after navigation
        if (onMobileToggle && isMobileOpen) {
            onMobileToggle();
        }
    };

    const isActive = (path) => {
        if (path === '/') {
            return location.pathname === '/' || location.pathname === '/dashboard';
        }
        return location.pathname === path;
    };

    return (
        <>
            {/* Mobile Menu Button */}
            <button
                onClick={onMobileToggle}
                className="md:hidden fixed top-4 left-4 z-50 p-2 bg-white rounded-lg shadow-md border border-gray-200"
            >
                {isMobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>

            {/* Mobile Overlay */}
            {isMobileOpen && (
                <div
                    className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
                    onClick={onMobileToggle}
                />
            )}

            {/* Sidebar */}
            <aside className={`
                fixed md:relative z-40 h-full
                ${isMobileOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
                transition-transform duration-300 ease-in-out
                w-64 md:w-16 lg:w-64 bg-white shadow-md flex flex-col
            `}>
                <div className="flex items-center justify-center lg:justify-start lg:pl-6 h-16 border-b">
                    <IndianRupee className="h-8 w-8 text-blue-600" />
                    <span className="hidden lg:block ml-3 text-xl font-bold text-gray-800 truncate" title={shopName}>
                        {shopName}
                    </span>
                </div>
                <nav className="flex-1 mt-6">
                    <ul>
                        {navItems.map(item => (
                            <li key={item.id} className="px-2">
                                <button
                                    onClick={() => handleNavigation(item)}
                                    className={`flex items-center w-full p-3 my-1 rounded-lg transition-colors duration-200 ${isActive(item.path)
                                        ? 'bg-blue-500 text-white shadow-sm'
                                        : 'text-gray-600 hover:bg-gray-200'
                                        }`}
                                >
                                    <item.icon className="h-6 w-6" />
                                    <span className="block lg:hidden xl:block ml-4 font-medium">{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            </aside>
        </>
    );
};

export default Sidebar;